import { order } from '@schuettflix/schema-registry-ts';
import { z } from 'zod';

export const BILLING_INTERVAL_SCHEMA = order.fulfillmentService.versions.v1.schemas.BILLING_INTERVAL_SCHEMA;
export type BILLING_INTERVAL = z.infer<typeof BILLING_INTERVAL_SCHEMA>;
